import BundleData from "../../../entities/manhattan/submit/BundleData";
import { IManhattanBundle } from "../../../entities/manhattan/bundle/types";
import { BundleProductLines } from "../../../constants/BundleProductLines";
import BundleDataPostOttSelectedProductsFactory from "./BundleDataPostOttSelectedProductsFactory";
import BundleDataFtthSelectedProductsFactory from "./BundleDataFtthSelectedProductsFactory";
import SelectedOttProduct from "../../../entities/manhattan/submit/SelectedOttProduct";

export default class BundleDataFactory {

  private readonly bundle: any;
  private readonly segment: string;
  private readonly lang: string;
  private readonly params?: any;


  constructor(bundle: IManhattanBundle, segment: string, lang: string, params?: any) {
    this.bundle = bundle;
    this.segment = segment;
    this.lang = lang;
    this.params = params;
  }

  public getSelectedProducts(bundle: IManhattanBundle, params: any) {
    const selectedProducts: any[] = [];

    switch (bundle.productLine.productLine) {
    case BundleProductLines.PURE_OTT:
      selectedProducts.push(new SelectedOttProduct(bundle.id, bundle.productLine.productLine));
      break;
    case BundleProductLines.POSTPAID_OTT:
      const bundleDataPostOttFactory = new BundleDataPostOttSelectedProductsFactory(bundle);
      selectedProducts.push(bundleDataPostOttFactory.create());
      break;
    case BundleProductLines.FTTH:
      const bundleDataFtthFactory = new BundleDataFtthSelectedProductsFactory(bundle, params);
      selectedProducts.push(bundleDataFtthFactory.create());
      break;
    }
    return selectedProducts;
  }

  public create() {
    return new BundleData(
      this.segment,
      this.getSelectedProducts(this.bundle, this.params),
      this.lang
    );
  }

}
